import { Store } from 'redux-thunk';
import { RouterState, RedirectFunction, RouteProps } from 'react-router';
import { APP_PATHS, getAllowedDestination } from './route-helpers';
import DomainView from '../views/domainView/domainView';
import IndustryView from '../views/industryView/industryView';
import ProductChoiceView from '../views/productChoiceView';
import PricingView from '../views/pricingView/pricingView';
import TemplateView from '../views/templateView/templateView';
import getConfig from '../config';
import { AppState } from '../redux/reducers';
import { isUserAllowedToEnterDolphin } from '../modules/helpers';
import { PRODUCT_TYPE_CREATOR } from '../modules/constants';
import { forwardToDolphinCms } from '../redux/actions/dolphin-cms';
import { ValidProductType } from 'src/redux/reducers/intent';
import { isAustraliaCountry } from '../modules/helpers';

export function adjustRouteIfNecessary(
  state: AppState,
  nextState: RouterState,
  replace: RedirectFunction
): string {
  const destinationPath = nextState.location.pathname;

  const newDestinationPath = getAllowedDestination(destinationPath, state);
  if (destinationPath !== newDestinationPath) {
    replace(newDestinationPath);
  }
  return newDestinationPath;
}

const handleProductChoicePerLanguage = (store: Store<AppState>) => (
  nextState: RouterState,
  replace: RedirectFunction,
  done: () => void
) => {
  const state = store.getState();
  const { ref } = state.affiliate;
  const { skipTemplateView } = state.template;
  const { country } = getConfig();
  const hasPreselectedCreator = state.intent.preSelectedProduct === (PRODUCT_TYPE_CREATOR as ValidProductType);
  const allowedToEnterDolphin = isUserAllowedToEnterDolphin(
    ref,
    skipTemplateView,
    hasPreselectedCreator
  );

  if (
    nextState.location.pathname === APP_PATHS.PRODUCT &&
    allowedToEnterDolphin &&
    isAustraliaCountry(country)
  ) {
    store.dispatch(forwardToDolphinCms());

    return;
  }

  done();
};

export const getAppRoutes = async (store: Store<AppState>): Promise<Partial<RouteProps>[]> => {
  return [
    {
      path: APP_PATHS.PRODUCT,
      component: ProductChoiceView,

      onEnter: handleProductChoicePerLanguage(store),
    },
    {
      path: APP_PATHS.INDUSTRY,
      component: IndustryView,
    },
    {
      path: APP_PATHS.TEMPLATE,
      component: TemplateView,
    },
    {
      path: APP_PATHS.PRICING,
      component: PricingView,
    },
    {
      path: APP_PATHS.DOMAIN,
      component: DomainView,
    },
  ];
};
